import React from "react";
import { ArrowRight, Sparkles, Play } from "lucide-react";
import { Button } from "./ui/button";
import { HERO_IMAGE } from "../mock";

const Hero = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative overflow-hidden bp-grid pt-32 pb-20 sm:pt-40 sm:pb-28">
      <div className="absolute top-0 right-0 h-72 w-72 bg-[#DC2626]/10 rounded-full blur-3xl -z-0" />
      <div className="absolute -bottom-10 -left-10 h-80 w-80 bg-[#1D4ED8]/10 rounded-full blur-3xl -z-0" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div className="animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#1D4ED8]/20 bg-blue-50 px-3.5 py-1.5 text-xs font-semibold text-[#1D4ED8]">
            <Sparkles className="h-3.5 w-3.5" />
            AI-powered · Built for the U.S. &amp; Canada
          </div>

          <h1 className="font-display mt-6 text-[2.6rem] leading-[1.05] sm:text-6xl font-700 tracking-tight text-[#0A2540]">
            Build your plan.
            <br />
            <span className="text-[#1D4ED8]">Know your </span>
            <span className="text-[#DC2626]">cost.</span>
          </h1>

          <p className="mt-6 text-lg text-slate-600 max-w-xl leading-relaxed">
            cost2build.ai turns your home, warehouse or commercial project into a
            ready-to-build scope of work — with contractor-grade material and labor
            estimates benchmarked to North American averages.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Button
              onClick={() => scrollTo("#estimator")}
              className="h-12 px-7 text-base bg-[#DC2626] hover:bg-[#b91c1c] text-white shadow-md group"
            >
              Get an instant estimate
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => scrollTo("#ai-tools")}
              variant="outline"
              className="h-12 px-7 text-base border-slate-300 text-[#0A2540] hover:border-[#1D4ED8] hover:text-[#1D4ED8]"
            >
              <Play className="mr-2 h-4 w-4" /> See the AI tools
            </Button>
          </div>

          <p className="mt-5 text-sm text-slate-500">
            <span className="font-semibold text-[#0A2540]">1,241</span> estimates run this week · No signup for a ballpark.
          </p>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-slate-200">
            <img
              src={HERO_IMAGE}
              alt="Modern home under construction"
              className="w-full h-[440px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A2540]/40 to-transparent" />
          </div>

          <div className="absolute -left-4 bottom-8 bg-white rounded-xl shadow-xl border border-slate-100 p-4 w-56 animate-floaty">
            <div className="text-xs text-slate-500">Estimated build cost</div>
            <div className="font-display text-2xl font-700 text-[#0A2540]">$486,200</div>
            <div className="mt-2 flex items-center gap-2 text-xs">
              <span className="inline-block h-2 w-2 rounded-full bg-[#1D4ED8]" /> Materials 54%
              <span className="inline-block h-2 w-2 rounded-full bg-[#DC2626] ml-2" /> Labor 46%
            </div>
          </div>

          <div className="absolute -right-3 top-8 bg-white rounded-xl shadow-xl border border-slate-100 px-4 py-3 animate-floaty" style={{ animationDelay: "1.5s" }}>
            <div className="flex items-center gap-2 text-sm font-semibold text-[#0A2540]">
              <Sparkles className="h-4 w-4 text-[#DC2626]" /> AI scope ready
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
